module.exports = __webpack_public_path__ + "img/Logo-chengtu.03c39fce.jpg";